import { useState } from "react";
function useCopyToClipboard({ onCopy, timeout = 2000 } = {}) {
    const [isCopied, setIsCopied] = useState(false);
    const copyToClipboard = async (value)=>{
        if ("undefined" == typeof globalThis || !navigator.clipboard.writeText) return;
        if (!value) return;
        try {
            await navigator.clipboard.writeText(value);
            setIsCopied(true);
            if (onCopy) onCopy();
            setTimeout(()=>{
                setIsCopied(false);
            }, timeout);
        } catch (error) {
            console.error(error);
        }
    };
    return {
        copyToClipboard,
        isCopied
    };
}
export { useCopyToClipboard };
